var ScriptKeys = {
    GTM_KEY: 'gtm',
    GA_KEY: 'ga',
    SEGMENT_KEY: 'segment',
    ANI_KEY: 'ani',
    BRAZE_KEY: 'braze',
    WEB_PUSH: 'webpush',
    SAFARI_PUSH_ID: 'safaripushid',
    COOKIE_YES_KEY: 'cookieyes',
    ICOMOON_VERSION: 'icomoon-version',
    SENTRY_KEY: 'sentry-is-active'
};
export default ScriptKeys;
